import store from "@/store";
import router from "@/router";

const myAxiosBackend = require('axios').default;
myAxiosBackend.defaults.baseURL = process.env.VUE_APP_API_HOST;
// axios defaultně serializuje pole jako `key[]=v1&key[]=v2`, ale FastAPI
// Query(List[...]) očekává opakovaný holý klíč `key=v1&key=v2` - {indexes: null}
// přepne serializaci na tento tvar pro všechna volání přes tuto instanci.
myAxiosBackend.defaults.paramsSerializer = {indexes: null};


myAxiosBackend.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Neautorizovaný přístup, odhlásit uživatele a přesměrovat na login page
      store.commit('logout');
      router.push('/login')
    }
    return Promise.reject(error);
  }
);

export default myAxiosBackend;